import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Extrawork from "./pages/Extrawork";
import SnlDatabaseForm from "./snlform/SnlDatabaseForm";
import ValidationPage from "./pages/ValidationPage";
import MyProfilePage from "./pages/MyProfilePage";
import UnifiedContract from "./pages/UnifiedContract";
import TitleHandler from "./components/TitleHandler";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import DocumentUpload from "./components/DocumentUpload";
import CodeLinkLogin from './components/Login/CodeLinkLogin';
import MobileTraining from "./components/training/MobileTraining";
import FooterNav from './components/footer/FooterNav';
import ProfileHome from './components/homepage/ProfileHome';
import { UserProvider } from './utils/UserContext';
import FiltersSupervisorPage from './pages/FiltersSupervisorPage';
import FilterDeparturePage from './pages/FilterDeparturePage';
import FilterClientPage from './pages/FilterClientPage';
import SuperOnboardPaged from './pages/SuperOnboardPaged';
import FilterSuperAddUpdatePagem from './pages/FilterSuperAddUpdatePagem';
import FilterSuperClientUpdatePagem from './pages/FilterSuperClientUpdatePagem';
import FilterStaffAddUpdatePagem from './pages/FilterStaffAddUpdatePagem';
import FilterSuperPersonalOnboardPagem from './pages/FilterSuperPersonalOnboardPagem';
import FilterSuperCalendarPagem from './pages/FilterSuperCalendarPagem';
import FilterSuperRecruitUpdatePagem from './pages/FilterSuperRecruitUpdatePagem';
import FilterSuperTestnTagUpdatePagem from './pages/FilterSuperTestNTagUpdatePagem';
import FilteredPayments from './components/payments/FilteredPayments';
import FiltersAdminPage from './pages/FiltersAdminPage';
import FiltersAdminPage2 from './pages/FiltersAdminPage2';
import FiltersAdminPage3 from './pages/FiltersAdminPage3';
import FiltersAdminPage4 from './pages/FiltersAdminPage4';
import ProtectedRoute from './utils/ProtectedRoute';
import FiltersStaffPage from './pages/FiltersStaffPage';
import ItworkPage from './pages/ItworkPage';
import FilterClientPersonalPagem from './pages/FilterClientPersonalPagem';
import FilterIgluPersonalPagem from './pages/FilterIgluPersonalPagem';
import FilterAvailablestaffm from './pages/FilterAvailablestaffm';
import FilterAvailablestaffd from './pages/FilterAvailablestaffd';
import FilterAvailablesuperm from './pages/FilterAvailablesuperm';
import FilterAvailablesuperd from './pages/FilterAvailablesuperd';
import { MessagesProvider } from './utils/MessagesContext';
import MessageCenter from './components/MessageCenter';

  

  
function App() {
  return (
    <Router>
    <UserProvider>
    <MessagesProvider>
      <div className="App">
        <TitleHandler />
        <ScrollToTop />
        <>
        <Routes>
          <Route path="/" element={<CodeLinkLogin />} />
          <Route path="/index" element={<Navigate to="/" />} />
          <Route path="/validlogin" element={<Navigate to="/" />} />
          <Route path="/validationpage" element={<ValidationPage />} />
          <Route path="/profile" element={<ProtectedRoute><ProfileHome /></ProtectedRoute>} />
          <Route path="/supervisorfiltersd" element={<ProtectedRoute><FiltersSupervisorPage /></ProtectedRoute>} />
          <Route path="/iglufiltersd" element={<ProtectedRoute><FilterDeparturePage /></ProtectedRoute>} />
          <Route path="/igluaddsm" element={<ProtectedRoute><FilterIgluPersonalPagem /></ProtectedRoute>} />
          <Route path="/superonboardd" element={<ProtectedRoute><SuperOnboardPaged /></ProtectedRoute>} />
          <Route path="/workavailabilitym" element={<ProtectedRoute><FilterAvailablestaffm /></ProtectedRoute>} />
          <Route path="/workavailabilityd" element={<ProtectedRoute><FilterAvailablestaffd /></ProtectedRoute>} />
          <Route path="/superworkavailabilitym" element={<ProtectedRoute><FilterAvailablesuperm /></ProtectedRoute>} />
          <Route path="/superworkavailabilityd" element={<ProtectedRoute><FilterAvailablesuperd /></ProtectedRoute>} />
          <Route path="/stafffiltersd" element={<ProtectedRoute><FiltersStaffPage /></ProtectedRoute>} />
          <Route path="/superleaveaddsm" element={<ProtectedRoute><FilterSuperAddUpdatePagem /></ProtectedRoute>} />
          <Route path="/itworkloadd" element={<ProtectedRoute><ItworkPage /></ProtectedRoute>} />
          <Route path="/superclientaddsm" element={<ProtectedRoute><FilterSuperClientUpdatePagem /></ProtectedRoute>} />
          <Route path="/testntagadminmobile" element={<ProtectedRoute><FilterSuperTestnTagUpdatePagem /></ProtectedRoute>} />
          <Route path="/superrecruitsm" element={<ProtectedRoute><FilterSuperRecruitUpdatePagem /></ProtectedRoute>} />
          <Route path="/staffaddsm" element={<ProtectedRoute><FilterStaffAddUpdatePagem /></ProtectedRoute>} />
          <Route path="/personalonboardm" element={<ProtectedRoute><FilterSuperPersonalOnboardPagem /></ProtectedRoute>} />
          <Route path="/clientaddsm" element={<ProtectedRoute><FilterClientPersonalPagem /></ProtectedRoute>} />
          <Route path="/clientfiltersd" element={<ProtectedRoute><FilterClientPage /></ProtectedRoute>} />
          <Route path="/adminfiltersd" element={<ProtectedRoute><FiltersAdminPage /></ProtectedRoute>} />
          <Route path="/adminfiltersd2" element={<ProtectedRoute><FiltersAdminPage2 /></ProtectedRoute>} />
          <Route path="/adminfiltersd4" element={<ProtectedRoute><FiltersAdminPage4 /></ProtectedRoute>} />
          <Route path="/adminfiltersd3" element={<ProtectedRoute><FiltersAdminPage3 /></ProtectedRoute>} />
          <Route path="/paymentportal" element={<ProtectedRoute><FilteredPayments /></ProtectedRoute>} />
          <Route path="/calendaradminmobile" element={<ProtectedRoute><FilterSuperCalendarPagem /></ProtectedRoute>} />
          <Route path="/trainingpage" element={<ProtectedRoute><MobileTraining /></ProtectedRoute>} />
          <Route path="/landingprofile" element={<MyProfilePage />} />
          <Route path="/contract" element={<UnifiedContract />} />
          <Route path="/documentforms" element={<DocumentUpload />} />
          <Route path="/snldatabaseform" element={<SnlDatabaseForm />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FooterNav/>
         <MessageCenter />
        </>
      </div>
      </MessagesProvider>
      </UserProvider>
    </Router>
  );
}

export default App;